import * as React from 'react';
import InputText from '../../../../../common/components/InputText';
import Button from '../../../../../common/components/Button';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {COUNTRIES} from '../../../../constants/AppConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import {ReferencesStepProps, ReferencesStepState} from '../../../../types/mx/creditoReal/components';

class ReferencesStepView extends React.Component<ReferencesStepProps, ReferencesStepState> {
    constructor(props) {
        super(props);

        const errorsFields = {};
        for (let i = 0; i < 3; i += 1) {
            errorsFields[`firstName${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].firstName ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`lastName${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].lastName ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`secondLastName${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].secondLastName ? null : ValidateConstant.ERROR_REQUIRED;
            errorsFields[`phone${i}Error`] = this.props.otherReferences[i] &&
            this.props.otherReferences[i].phone ? null : ValidateConstant.ERROR_REQUIRED;
        }

        // @ts-ignore
        this.state = {
            references: this.props.otherReferences.length > 0 ? this.props.otherReferences :
                Array.from(Array(COUNTRIES.MX.totalReferences).keys(),
                    () => ({firstName: '', lastName: '', secondLastName: '', phone: ''})),
            ...errorsFields,
            areReferencesRepeatedError: false,
            showErrors: false,
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onChangeInput = (value, error, id, index) => {
        const newReferenceDataArray = [...this.props.otherReferences];
        newReferenceDataArray[index] = {...this.props.otherReferences[index], [id]: value};

        const references = [...this.state.references];
        references[index] = {...this.state.references[index], [id]: value};
        this.setState({references});

        this.props.onChangeOtherReferences(newReferenceDataArray);

        // @ts-ignore Todo: @mono Refactorizar typescripts
        this.setState({[`${id}${index}Error`]: error});
    }

    areReferencesDifferent = () => {
        let areDifferent = true;
        const {otherReferences} = this.props;
        const refLength = otherReferences.length;

        for (let i = 0; i < refLength; i += 1) {
            for (let j = i + 1; j < refLength; j += 1) {
                const firstNameDiff = otherReferences[i].firstName === otherReferences[j].firstName;
                const lastNameDiff = otherReferences[i].lastName === otherReferences[j].lastName;
                const secondLastNameDiff = otherReferences[i].secondLastName === otherReferences[j].secondLastName;
                const phoneDiff = otherReferences[i].phone === otherReferences[j].phone;
                if ((firstNameDiff && lastNameDiff && secondLastNameDiff) || phoneDiff) {
                    areDifferent = false;
                }
            }
        }
        return areDifferent;
    }

    allFieldsAreValid = () => {

        const refLength = COUNTRIES.MX.totalReferences;

        let areValid = true;

        for (let i = 0; i < refLength; i += 1) {
            areValid = this.state[`firstName${i}Error`] == null &&
                        this.state[`lastName${i}Error`] == null &&
                        this.state[`secondLastName${i}Error`] == null &&
                        this.state[`phone${i}Error`] == null;
            if (!areValid) {
                break;
            }
        }

        return areValid;
    }

    onPressNext = () => {
        const areRefDifferent = this.areReferencesDifferent();
        if (this.allFieldsAreValid() && areRefDifferent) {
            this.props.onPressNext();
            this.setState({
                showErrors: false,
                areReferencesRepeatedError: false
            });
        } else {
            this.setState({
                showErrors: true,
                areReferencesRepeatedError: !areRefDifferent
            });
        }
    }

    renderReference(index, label) {
        if (this.state.references[index]) {
            return (
                <div className="row">
                    <div className="col-12">
                        <div className="header-bar mb-3">{label}</div>
                        <div className="row mb-4">
                            <div className="col-lg-3 pr-3">
                                <InputText id={INPUTS.FIRST_NAME} label={LOAN_APPLICATION_MX.REFERENCES_NAME}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.state[`${INPUTS.FIRST_NAME}${index}Error`]}
                                           value={this.state.references[index].firstName}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'firstName', index)}/>
                            </div>
                            <div className="col-lg-3 pr-3">
                                <InputText id={INPUTS.LAST_NAME} label={LOAN_APPLICATION_MX.LAST_NAME}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.state[`${INPUTS.LAST_NAME}${index}Error`]}
                                           value={this.state.references[index].lastName}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'lastName', index)}/>
                            </div>
                            <div className="col-lg-3 pr-3">
                                <InputText id={INPUTS.SECOND_LAST_NAME} label={LOAN_APPLICATION_MX.SECOND_LAST_NAME}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.state[`${INPUTS.SECOND_LAST_NAME}${index}Error`]}
                                           value={this.state.references[index].secondLastName}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'secondLastName', index)}/>
                            </div>
                            <div className="col-lg-3 pr-3">
                                <InputText id={INPUTS.PHONE} label={LOAN_APPLICATION_MX.CONTACT_NUMBER}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.state[`${INPUTS.PHONE}${index}Error`]}
                                           maxLength={10}
                                           minLength={10}
                                           type={InputTextTypes.NUMBER}
                                           value={this.state.references[index].phone}
                                           onChange={(value, error) =>
                                               this.onChangeInput(value, error, 'phone', index)}/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {

        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION_MX.REFERENCES}</h3>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <p>{LOAN_APPLICATION_MX.REFERENCE_DESCRIPTION}</p>
                    </div>
                </div>
                <div className="row border-bottom">
                    <div className="col-12">

                        {this.renderReference(0, LOAN_APPLICATION_MX.REFERENCE_1)}
                        {this.renderReference(1, LOAN_APPLICATION_MX.REFERENCE_2)}
                        {this.renderReference(2, LOAN_APPLICATION_MX.REFERENCE_3)}

                        {this.state.areReferencesRepeatedError &&
                        <div className="row justify-content-end">
                            <div className="col form-text is-invalid py-3">
                                {ValidateConstant.ERROR_REPEATED_REFERENCE}
                            </div>
                        </div>}

                    </div>
                </div>
                <div className="row mt-4 mb-3">
                    <div className="col-12 d-flex justify-content-between">
                        <Button text={LOAN_APPLICATION_MX.NEXT}
                                onPress={this.onPressNext}
                                role="button"
                                customClass="ml-auto px-md-5 btn-block"/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ReferencesStepView;